import { render } from "./SaleTextSetting.vue?vue&type=template&id=f1a0f30a"
import script from "./SaleTextSetting.vue?vue&type=script&lang=js"
export * from "./SaleTextSetting.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__